// API配置文件
export const API_CONFIG = {
  BASE_URL: 'https://erp.partsgopro.com/'
}

// 获取完整的API URL
export const getApiUrl = (endpoint) => {
  return `${API_CONFIG.BASE_URL}${endpoint}`
} 